import { ActionBrick, registerBrick, Transaction, defineProperty } from 'olympe';
import { Color } from 'olympe';

const chartDynamicTag = '0193b5f7aa81ee38997d';
const nameProp = defineProperty('018d7898ac2778bf7ef7');
const axisProp = defineProperty('018d6972810742c33659');
const typeProp = defineProperty('018d305923879d1e4349');
const orderProp = defineProperty('018d3059695ec27d19ce');
const xPathProp = defineProperty('018d3059886e4a4b0bd0');
const yPathProp = defineProperty('018d305996712f4daf27');
const rPathProp = defineProperty('018d7e857e99f3aa2a6d');
const colorPathProp = defineProperty('018d3059bef45490bcb2');
const legendProp = defineProperty('018d3059eed173a05995');
const colorProp = defineProperty('018d305a0a6b9ceff9b1');
const displayDataLabels = defineProperty('018d7f1238ef3bdbac61');
const configJSONProp = defineProperty('018d305b6e323b35ec27');

/*
[
  {
    "equipment_name":"F1M1",
    "usage_count":"2",
    "avg_production_output":"110.0000000000000000"
  },
  {
    "equipment_name":"F1M2",
    "usage_count":"1",
    "avg_production_output":"200.0000000000000000"
  },
  {
    "equipment_name":"F1M3",
    "usage_count":"1",
    "avg_production_output":"50.0000000000000000"
  }
]
*/
export class CodedCreateChartDynamic extends ActionBrick {
    /**
     * @override
     * @protected
     * @param {!BrickContext} $
     * @param {*} data
     * @param {function()} forwardEvent
     * @param {function(*)} setData
     */
    update($, [data], [forwardEvent, setData]) {
        // Write your code here.
        // Check https://olympe.support for documentation.
        // Check https://github.com/olympeio/CORE for examples.
        //
        // This method is executed every time the brick's input Control Flow is triggered.
        // Override `setupExecution()` to change this behavior.
        const fields = Object.keys(data[0]);
        const xProp = fields[0];

        const t = new Transaction(false);
        const types = ["bar"]; // types[Math.floor(Math.random() * types.length)]
        const axis = ['First (left)', 'Second (right)'];

        const COLORS = [
            Color.create(54, 162, 235),  // blue
            Color.create(255, 99, 132),  // red
            Color.create(255, 159, 64),  // orange
            Color.create(255, 205, 86),  // yellow
            Color.create(75, 192, 192),  // green
            Color.create(153, 102, 255), // purple
            Color.create(201, 203, 207)  // grey
          ];

        for (const yProp of fields.slice(1)) {
            const properties = new Map();
            const i = fields.indexOf(yProp);
            properties.set(nameProp, 'data');
            properties.set(typeProp, 'bar');
            properties.set(xPathProp, xProp);
            properties.set(yPathProp, yProp);
            properties.set(colorProp, COLORS[(i-1)%7]);
            properties.set(legendProp, yProp);
            properties.set(axisProp, axis[(i+1)%2]);
            t.create(chartDynamicTag, properties);
        }

        t.execute().then(() => {
            setData({ data });
            forwardEvent();
        });
    }
}

registerBrick('0193bfaf7a6a9049f18e', CodedCreateChartDynamic);
